(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.yvHeroInit === '1') return;
    root.dataset.yvHeroInit = '1';

    var wordmark = root.querySelector('.yv-hero__wordmark');
    var panels = root.querySelector('.yv-hero__panels');
    if (!wordmark || !panels) return;

    var ticking = false;

    function update() {
      var wm = wordmark.getBoundingClientRect();
      var panelsBottom = panels.getBoundingClientRect().bottom;
      var wmCenter = wm.top + wm.height / 2;
      root.classList.toggle('is-on-white', panelsBottom <= wmCenter);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-yv-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
